export default "__VITE_ASSET__BD8ZgAkr__"